import React, { useEffect, useState, useRef } from 'react';
//import { LayoutWorkato } from "../../layouts/layout-workato";
import { LayoutDashboard3col } from '../../layouts/layout-dashboard-3col';
import { Row, Col, Container, Tabs, Tab, Button } from 'react-bootstrap';
import { Nav } from '../../components/nav';
import { Breadcrumb } from '../../components/breadcrumb';
//import { Search } from "../../components/search";
import { useParams } from 'react-router-dom';
import { useAxios } from '../../hooks/useAxios';
//import { WorkatoEmbedClient } from "../../components/workato/workato-embed-client";
import { BasicCombinationWorkflow } from '../../components/basic-combination-workflow';
import { Preloader } from '../../components/preloader';
import { RecipeStartStop } from '../../components/workato/button-workato-recipe-start-stop';
import { WorkatoConnectinoData } from '../../data/workato/connection-status';
import { CombinationSideBar } from '../../components/combination-sidebar';
//import { JobsMain } from "../../components/combinations-jobs";
import { Console } from '../../services/platform-api';
import { CombinationInfoPanel } from '../../components/combination-info-panel';
//import { GetAllRecipes_GetThisRecipe } from '../../data/platform/get_workato_recipe_lookup';
import { useSessionStorage } from '../../hooks/useSessionStorage';
//import { BetaRight } from '../../components/beta-header';x

const BasicCombination = (props) => {
  //WorkatoEmbedClient();
  const [isPreloading, setIsPreloading] = useState(true);

  const { data: combinationData = null, fetchNow: setCombinationData } = useAxios();
  const { data: recipeData = null, fetchNow: setRecipeData } = useAxios();
  const [refreshRecipe, setRefreshRecipe] = useState(false);
  const [recipeActive, setRecipeActive] = useState(false);
  const [recipeDisabled, setRecipeDisabled] = useState(false);
  const [recipeDetails, setRecipeDetails] = useState(null);
  const [activeTab, setActiveWFTab] = useState('wf-conn-0');
  const [userId] = useSessionStorage('userId', '');
  const [workato_id] = useSessionStorage('workatoId', '');
  const arc_tab_ref1 = useRef(null);
  const arc_tab_ref2 = useRef(null);
  let { id } = useParams();
  id = parseInt(id);

  Console('workato_id: ', workato_id, 'log');
  Console('user ID....: ', userId, 'log');
  let workato_recipe_id = null;
  let workato_recipe_webhook = null;
  let recipe_setup_status = null;

  // get our workato recipe combo data from platform
  // TEMP
  let workato_connection_data = {};
  workato_connection_data = WorkatoConnectinoData(id, true); // id - is basic = true
  const { workato_recipe, conns_connected } = workato_connection_data;
  workato_recipe_id = workato_recipe?.recipe_id;
  workato_recipe_webhook = workato_recipe?.workato_webhook;
  if (workato_recipe?.status) {
    recipe_setup_status = workato_recipe?.status;
  }

  useEffect(() => {
    if (workato_id === null || workato_id === undefined) return;

    const headers = {
      'Content-type': 'application/json',
      'x-user-email': 'integrations@arcanum.ai',
      'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
    };

    if (combinationData === null) {
      setCombinationData(`/api/platform/combination/${id}/`, 'GET', null, false);
    }

    if ((workato_recipe_id && recipeData === null) || refreshRecipe) {
      setRecipeData(
        `/api/platform/proxy?url=api/managed_users/${workato_id}/recipes/${workato_recipe_id}`,
        'GET',
        null,
        headers,
      );
      setRefreshRecipe(false);
    } else if (recipeData !== null && combinationData !== null) {
      let merged_data;

      Console('recipeData ', recipeData, 'log');
      // hybrid our combination data with the workato recipe data.
      merged_data = { ...recipeData, ...combinationData };

      setRecipeActive(recipeData?.running);
      setRecipeDetails(merged_data);
      Console('merged data end fo useeffect', merged_data, 'log');
      setIsPreloading(false);
    }
  }, [id, recipeData, combinationData, workato_recipe_id, workato_id, refreshRecipe]);

  // this will refresh our recipe data from above several times
  const refreshTheRecipe = () => {
    setRefreshRecipe(true);
  };

  if (isPreloading) {
    return <Preloader />;
  }

  return (
    <>
      {recipeDetails && combinationData && workato_id !== 1 ? (
        <div className="dashboard">
          <header>
            <Container fluid>
              <Row>
                <Col lg={9} md={9} className="px-5">
                  <Breadcrumb label={recipeDetails?.sub_title.replace('(basic)', '')} />
                  <h1>{recipeDetails?.name.replace('(basic)', '')}</h1>
                </Col>

                <Col lg={3} className="px-5 text-end">
                  {recipe_setup_status === 'complete' ? (
                    <RecipeStartStop
                      recipeStatus={recipeActive}
                      setRecipeActive={setRecipeActive}
                      recipeDisabled={recipeDisabled}
                      recipeID={workato_recipe_id}
                    />
                  ) : recipe_setup_status !== 'complete' && recipe_setup_status !== 'started' ? (
                    <>
                      <h6 className="pt-4">setting up....</h6>
                    </>
                  ) : null}
                </Col>
              </Row>
            </Container>
          </header>
          <Container fluid className="px-5 mt-5">
            <Row>
              <Col>
                <LayoutDashboard3col
                  col1={
                    <BasicCombinationWorkflow
                      workflowData={combinationData}
                      arc_tab_ref1={arc_tab_ref1}
                      arc_tab_ref2={arc_tab_ref2}
                      setActiveWFTab={setActiveWFTab}
                      recipeName={recipeDetails?.name}
                    />
                  }
                  col2={
                    <CombinationInfoPanel
                      workato_recipe_id={workato_recipe_id}
                      arc_tab_ref1={arc_tab_ref1}
                      arc_tab_ref2={arc_tab_ref2}
                      workflowData={combinationData}
                      activeTab={activeTab}
                      manual={true}
                      webhook_url={workato_recipe_webhook}
                      recipeSetupStatus={recipe_setup_status}
                      recipeActive={recipeActive}
                      connected={conns_connected}
                      refreshTheRecipe={refreshTheRecipe}
                      setRecipeDisabled={setRecipeDisabled}
                    />
                  }
                  //  Hard coded for demo
                  sidebar={<CombinationSideBar recipeStatus={recipeActive} recipeDetails={recipeDetails} />}
                ></LayoutDashboard3col>
              </Col>
            </Row>
          </Container>

          <Nav nav1on="on" nav2on="" nav3on="" {...props} />
        </div>
      ) : null}
    </>
  );
};

export { BasicCombination };
